// Central source of truth for all product data
// Update prices here and they'll propagate across the entire site

export interface Product {
  key: string;
  name: string;
  displayName: string;
  description: string;
  price: number;
  originalPrice: number;
  path: string;
}

export const PRODUCTS = {
  brainCharge: {
    key: "brainCharge",
    name: "Brain Charge™",
    displayName: "Brain Charge™",
    description: "Premium nootropic for focus, memory & mental clarity",
    price: 79.99,
    originalPrice: 79.99,
    path: "/products/brain-charge",
  },
} as const;

export type ProductKey = keyof typeof PRODUCTS;

// Helper function to get product by key
export function getProduct(key: ProductKey): Product {
  return PRODUCTS[key];
}

// Calculate savings
export function getSavings(key: ProductKey): number {
  const product = PRODUCTS[key];
  return Number((product.originalPrice - product.price).toFixed(2));
}

// Format price for display
export function formatPrice(price: number): string {
  return `$${price.toFixed(2)}`;
}

// Get discount percentage
export function getDiscountPercent(key: ProductKey): number {
  const product = PRODUCTS[key];
  return Math.round((1 - product.price / product.originalPrice) * 100);
}
